import React from 'react';
import CancelInvitation from './CancelInvitation';
import ResendInvitation from './ResendInvitation';
import EmailAddress from 'components/EmailAddress';
import FormattedDate from 'components/FormattedDate';
import useCollectionQuery from 'hooks/useCollectionQuery';
import DataTable, { Columns } from 'system/data/DataTable';
import { InvitationsQuery, InvitationsQueryVariables } from 'types/graphql';
import { ID, matchNodes } from 'util/localTypes';

type Props = {
  organizationId: ID;
  query: any;
};

const Invitations = ({ organizationId, query }: Props) => {
  const { data, loading, error, loadMore } = useCollectionQuery<
    InvitationsQuery,
    InvitationsQueryVariables
  >({
    query,
    variables: { organizationId },
    path: ['organization', 'invitations'],
  });

  const refetchQueries = [
    { query, variables: { organizationId, after: null } },
  ];

  const collection = matchNodes(
    data?.organization,
    'Organization',
    (o) => o.invitations.nodes
  );

  const columns: Columns<typeof collection> = [
    { heading: 'Name', primary: true, render: ({ name }) => name },
    {
      heading: 'Email Address',
      render: ({ email }) => <EmailAddress address={email} />,
    },
    {
      heading: 'Expiry',
      render: ({ expiresAt }) => <FormattedDate date={expiresAt} />,
    },
    {
      heading: 'Re-send invitation',
      render: (i) => (
        <ResendInvitation invitation={i} organizationId={organizationId} />
      ),
    },
    {
      heading: 'Cancel invitation',
      render: (i) => (
        <CancelInvitation invitation={i} refetchQueries={refetchQueries} />
      ),
    },
  ];

  return (
    <DataTable
      loading={loading}
      error={error}
      loadMore={loadMore}
      collection={collection}
      columns={columns}
      empty="There are no pending invitations"
    />
  );
};

export default Invitations;
